import styled from '@emotion/styled';
import { Button as _Button, Typography } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import { SPACING_REGULAR } from '../../constant/spacing';
import { gridLayoutContainer, gridLayoutItem } from '../../styleUtility/gridLayout';
import mq from '../../styleUtility/mediaquery';

interface Props {
  className?: string;
  modificationRequestState?: string;
}

const ModificationRequestAlreadySentCard = ({
  className,
  modificationRequestState,
}: ClassAttributes<HTMLElement> & Props) => {
  const formattedMessage =
    modificationRequestState === 'submitted' ? (
      <FormattedMessage id="modification_request_already_sent_card.description" />
    ) : null;

  return (
    <Root className={className}>
      <Description>{formattedMessage}</Description>
    </Root>
  );
};

const Root = styled('div')(
  gridLayoutContainer({
    columns: ['4fr', `${SPACING_REGULAR}px`, '1fr'],
    rows: ['auto'],
    areas: [['description']],
    alignItems: 'center',
  }),
  {
    paddingBottom: SPACING_REGULAR,
    [mq('sp')]: {
      ...gridLayoutContainer({
        columns: ['1fr'],
        rows: ['auto', '8px', 'auto'],
        areas: [['description']],
      }),
    },
  },
);

const Description = styled(Typography)(gridLayoutItem('description'));

export default ModificationRequestAlreadySentCard;
